import React from 'react'
import get from 'lodash/get'

class RadarPage extends React.Component {
    render(){
        const links = get(this, 'props.data.allLinksJson.edges')

        return (
            <div>
                <ul>
                { links.map( link => {
                    return (
                    <li>
                    <a href="{link.node.url}">{link.node.title}</a>
                    </li>
                    )
                })}
                </ul>
            </div> 
        )
    }

}

export default RadarPage

export const pageQuery=graphql`
query RadarQuery {
    allLinksJson(sort: {fields:[timestamp],order:DESC}) {
        edges {
            node {
                title
                timestamp
                url
            }
        }
    }
}
`


// WEBPACK FOOTER //
// ./src/pages/radar.js